// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"799":"f60070c0","816":"dec4d00f","867":"d998dccf"}[chunkId] + ".js";
};